import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import Cookies from 'universal-cookie';
const cookies = new Cookies();


export const PostAPI = async (url, body, header) => {
    const requestOptions = {
        method: 'POST',
        url: url,
        headers:  ( header !== undefined ) ?  header : { clientToken: cookies.get('clientToken'), 'Cache-Control': 'no-cache' },
        data: body
    };

    // const response = await trackPromise(axios(requestOptions));
    
    const response = await trackPromise(
        axios(requestOptions)
        .then(function(res) {
            return res;
        })
        .catch(function(error){
            const res = {
                status: 400,
                message: error
            }
            return res;
        })
        );
    
    return response;
}